import React from "react";
import Typography from "../../Typography";
import "../css/Testimonials.css";

const testimonials1 = [
  {
    name: "Michael Wood",
    role: "Client",
    image: "./imgs/testimonials/man/1.jpg",
    text:
      "Absolutely amazing work! The details in my tattoo are stunning, and the artist made sure everything was perfect. I’ll definitely be coming back for more!",
  },
  {
    name: "Sophia Carter",
    role: "Client",
    image: "./imgs/testimonials/women/1.jpg",
    text:
      "Such talented artists! They listened to my ideas and turned them into a masterpiece. The whole experience was smooth and enjoyable!",
  },
  {
    name: "James Roberts",
    role: "Client",
    image: "./imgs/testimonials/man/2.jpg",
    text:
      "Creative and professional! My tattoo healed perfectly, and I get compliments on it all the time. Highly recommended!",
  },
  {
    name: "Emma Johnson",
    role: "Client",
    image: "./imgs/testimonials/women/2.jpg",
    text:
      "Super clean and professional environment. The artist was patient and really made sure I was comfortable before starting. I love my new ink!",
  },
  {
    name: "Liam Harris",
    role: "Client",
    image: "./imgs/testimonials/man/3.jpg",
    text:
      "I was nervous before getting my first tattoo, but the team made me feel at ease. The result exceeded my expectations!",
  },
  {
    name: "Olivia Martin",
    role: "Client",
    image: "./imgs/testimonials/women/3.jpg",
    text:
      "I couldn’t be happier with my tattoo! The artist took my idea and made it even better. The shading and details are just incredible!",
  },
  {
    name: "Daniel Lewis",
    role: "Client",
    image: "./imgs/testimonials/man/4.jpg",
    text:
      "Best tattoo experience I’ve ever had! The team was friendly, professional, and extremely skilled. I already booked my next session!",
  },
  {
    name: "Ava Wilson",
    role: "Client",
    image: "./imgs/testimonials/women/4.jpg",
    text:
      "I’ve been to many tattoo studios, but this one stands out. The level of precision and creativity is next-level. Can’t wait to return!",
  },
  {
    name: "Noah Adams",
    role: "Client",
    image: "./imgs/testimonials/man/5.jpg",
    text:
      "I gave them a rough sketch of what I wanted, and they turned it into a work of art. Absolutely mind-blowing talent!",
  },
  {
    name: "Ethan Bennett",
    role: "Client",
    image: "./imgs/testimonials/man/6.jpg",
    text:
      "From start to finish, the experience was amazing. The artist was patient, skilled, and truly passionate about their craft!",
  },
  {
    name: "Charlotte Walker",
    role: "Client",
    image: "./imgs/testimonials/women/5.jpg",
    text:
      "If you're looking for precision and creativity, this is the place. My tattoo is flawless, and I couldn't be happier with it!",
  },
  {
    name: "Mia Scott",
    role: "Client",
    image: "./imgs/testimonials/women/6.jpg",
    text:
      "I was worried about the pain, but the artist made me feel at ease. The whole process was smooth, and the tattoo is absolutely stunning!",
  },
  {
    name: "Benjamin Hall",
    role: "Client",
    image: "./imgs/testimonials/man/7.jpg",
    text:
      "The details in my tattoo are unreal! I’m beyond impressed with the skill and professionalism of this studio. Worth every penny!",
  },
  {
    name: "John Turner",
    role: "Client",
    image: "./imgs/testimonials/man/8.jpg",
    text:
      "I’ve been dreaming of this tattoo for years, and they made it better than I imagined. The whole process was so comfortable and professional!",
  },
  {
    name: "Mason Green",
    role: "Client",
    image: "./imgs/testimonials/man/9.jpg",
    text:
      "An incredible experience! The artists are true professionals, and the atmosphere in the studio is so welcoming. Highly recommend it!",
  },
];

const testimonials2 = [
  {
    name: "Lily Prom",
    role: "Client",
    image: "./imgs/testimonials/women/7.jpg",
    text:
      "I can’t stop looking at my tattoo! The details, shading, and precision are top-notch. I’ll definitely be back for more!",
  },
  {
    name: "Emily Davis",
    role: "Client",
    image: "./imgs/testimonials/women/8.jpg",
    text:
      "This was my first tattoo, and I was so nervous, but the artist walked me through everything. The result is absolutely stunning!",
  },
  {
    name: "Daniel White",
    role: "Client",
    image: "./imgs/testimonials/man/10.jpg",
    text:
      "Best tattoo studio I’ve ever been to! The environment is welcoming, and the artists truly care about their work!",
  },
  {
    name: "Olivia Brown",
    role: "Client",
    image: "./imgs/testimonials/women/9.jpg",
    text:
      "I was blown away by the professionalism here! The artist took their time and made sure every little detail was perfect.",
  },
  {
    name: "William Harris",
    role: "Client",
    image: "./imgs/testimonials/man/11.jpg",
    text:
      "I’ve had tattoos before, but this was by far the best experience. The artist was patient, creative, and incredibly skilled!",
  },
  {
    name: "Sophia Evans",
    role: "Client",
    image: "./imgs/testimonials/women/10.jpg",
    text:
      "The quality of work here is unreal! The lines are crisp, the shading is perfect, and the whole process was smooth and painless!",
  },
  {
    name: "Logan Mitchell",
    role: "Client",
    image: "./imgs/testimonials/man/12.jpg",
    text:
      "A fantastic experience from start to finish! The artist was professional, friendly, and truly passionate about their work!",
  },
  {
    name: "Ethan Thompson",
    role: "Client",
    image: "./imgs/testimonials/man/13.jpg",
    text:
      "I get compliments on my tattoo daily! The amount of detail and precision is just incredible. Highly recommended!",
  },
  {
    name: "Ava Parker",
    role: "Client",
    image: "./imgs/testimonials/women/11.jpg",
    text:
      "I love how they took the time to understand my vision and brought it to life. The final tattoo exceeded my expectations!",
  },
  {
    name: "Mia Anderson",
    role: "Client",
    image: "./imgs/testimonials/women/12.jpg",
    text:
      "The best tattoo studio I’ve been to! Super clean, professional, and the artists are extremely talented!",
  },
  {
    name: "Lucas Wright",
    role: "Client",
    image: "./imgs/testimonials/man/14.jpg",
    text:
      "Amazing experience! The artist was super friendly and made sure I was comfortable throughout the whole session!",
  },
  {
    name: "Isabella Lewis",
    role: "Client",
    image: "./imgs/testimonials/women/13.jpg",
    text:
      "My tattoo looks incredible! The artist was so precise and detailed, and the studio had a great vibe!",
  },
  {
    name: "Henry Walker",
    role: "Client",
    image: "./imgs/testimonials/man/15.jpg",
    text:
      "A true artist at work! I’m beyond happy with my tattoo and can’t wait to get another one soon!",
  },
  {
    name: "Charlotte Carter",
    role: "Client",
    image: "./imgs/testimonials/women/14.jpg",
    text:
      "Great experience from start to finish! The team is friendly, the studio is clean, and the results are flawless!",
  },
  {
    name: "Jack Robinson",
    role: "Client",
    image: "./imgs/testimonials/women/15.jpg",
    text:
      "I was hesitant at first, but now I wish I had done this sooner. The artist exceeded all my expectations!",
  },
];

export default function Testimonials() {
  return (
    <div className="testimonials-container relative">
      <div className="testimonials-columns">
        {/* Left Column - Scrolls Up */}
        <div className="testimonials-column testimonials-up">
          <div className="testimonials-wrapper">
            {testimonials1.concat(testimonials1).map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="flex items-center gap-2">
                  <img
                    alt="Client img"
                    className="w-[70px] rounded-full grayscale"
                    src={testimonial.image}
                  />
                  <div>
                    <Typography.P className="font-semibold">
                      {testimonial.name}
                    </Typography.P>
                    <Typography.P className="opacity-70">
                      {testimonial.role}
                    </Typography.P>
                  </div>
                </div>
                <Typography.Smp className="mt-2">
                  {testimonial.text}
                </Typography.Smp>
              </div>
            ))}
          </div>
        </div>

        {/* Right Column - Scrolls Down */}
        <div className="testimonials-column testimonials-down">
          <div className="testimonials-wrapper">
            {testimonials2.concat(testimonials2).map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="flex items-center gap-2">
                  <img
                    alt="Client img"
                    className="grayscale w-[70px] rounded-full"
                    src={testimonial.image}
                  />
                  <div>
                    <Typography.P className="font-semibold">
                      {testimonial.name}
                    </Typography.P>
                    <Typography.P className="opacity-70">
                      {testimonial.role}
                    </Typography.P>
                  </div>
                </div>
                <Typography.Smp className="mt-2">
                  {testimonial.text}
                </Typography.Smp>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
